import * as Models from '../../../../models';
import { Api2_0 } from '../../../../mappers/backend-types';
import { AcademiesEndpoints, AvatarsEndpoints, StudentsEndpoints } from '../../../../endpoint';

export const getAcademies = async (codes: Models.ChallengeAcademyType[]): Promise<Api2_0.Academy[]> => {
  if (codes.length > 0) {
    const response = await AcademiesEndpoints.getAcademies({ pageSize: codes.length });
    return response.resources;
  }
  return [];
};
export const getStudents = async (ids: Models.UserId[]): Promise<Api2_0.StudentProfile[]> => {
  if (ids.length > 0) {
    const response = await StudentsEndpoints.getProfile({ filters: { ids }, pageSize: ids.length });
    return response.resources;
  }
  return [];
};
export const getUserAvatars = async (ids: Models.UserId[]): Promise<Api2_0.Avatar[]> => {
  if (ids.length > 0) {
    const response = await AvatarsEndpoints.getAvatars();
    return response.resources;
  }
  return [];
};
